// vue draggable was more or less abandoned, so we switch to vue-draggable-plus
// as part of the am3 upgrade project, october 2024
import { VueDraggable } from 'vue-draggable-plus'
import { defineNuxtPlugin } from 'nuxt/app'

export default defineNuxtPlugin((nuxtApp) => {
  nuxtApp.vueApp.component('draggable', VueDraggable)
  // console.log( nuxtApp.vueApp )
})
